module.exports = __webpack_public_path__ + "static/media/high-difficulty.475e4727.svg";